/* Base translations · Documents and document library — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): docsExtras, docLibExtras, docLibStages, docFields, docLibHeaders, docLib, docsum, addFromLibrary. */
export const I18N_BASE_DOCUMENTS = {
  en: {
    docsExtras: {
      duplicateBadge: "Possible duplicate of {ref}",
      permanentFile: "Permanent file",
      permanentSuggested: "Suggested for the permanent file",
      permanentFailed: "Could not save the permanent-file tick",
      duplicatePrompt: "This file already exists as {ref} — upload anyway?",

      linkedToPlural: "Linked to {plural}",
      linkFailed: "Link update failed",
      docDeleted: "Document deleted",
      deleteFailed: "Delete failed",
      linkedTick: "Linked ✓",
      acceptFailed: "Accept failed",
      dismissFailed: "Dismiss failed",
      uploadFailedLine: "{name}: {msg}",
      uploadedSingle: "Uploaded — AI extraction started",
      uploadedBatch: "{ok} of {total} uploaded — AI is extracting fields in the background",
      uploadFailedSingle: "Upload failed",
      dropzoneTitle: "Click to pick files, or drag and drop multiple files here",
      uploadingProgress: "Uploading {done}/{total}…",
      dropToUpload: "Drop files to upload",
      uploadOrClick: "{upload} · drop or click · max 100 MB each",
      docsCount: "Documents ({n})",
      groupedTitle: "Grouped by Account Head",
      groupedLabel: "Grouped",
      flatTitle: "Flat list",
      flatLabel: "Flat",
      expandAll: "Expand all",
      collapseAll: "Collapse all",
      autoLinkedCount: "{n} AI-auto-linked",
      possibleCount: "{n} with possible AI match",
      noDocsYet: "No documents yet.",
      zoomTitle: "Open full-screen preview",
      zoomBtn: "Zoom",
      selectDoc: "Select a document",
      browserBlockedPdf: "Your browser blocked the inline PDF viewer.",
      downloadPdf: "Download the PDF",
      demoDoc: "Demo document (no file bytes)",
      colUid: "UID",
      colVoucher: "Voucher",
      colAccount: "Account",
      colAmount: "Amount",
      noSampleLines: "No sample lines yet — run a sample first.",
      saveWithCount: "Save ({n})",
      docPreview: "Document preview",
      docZoomAlt: "preview",
      aiConfidenceTitle: "AI auto-linked · {n}% confidence",
      unclassifiedBadge: "unclassified",
      unclassifiedWhy: "Auto-detect could not match this file to a support-document type (invoice, PO, GRN, contract, BOQ, delivery note, bank statement). Board minutes and audited financial statements are not support documents — set the type manually or leave it here.",
      extractionFailed: "Extraction failed — retry",
      possibleAiMatches: "Possible AI matches",
      dismissBtn: "Dismiss",
      acceptBtn: "Accept",
    },
    docLibExtras: {
      title: "Document Library",
      overview: "All {total} forms — {inEng} in this engagement, {avail} available to add. Deleted forms remain here to re-add.",
      inEngagement: "In this engagement",
      addToEng: "Add to engagement",
      noMatch: "No forms match \"{q}\".",
      failedLoad: "Failed to load library",
      failedAdd: "Failed to add form",
      failedBatch: "Failed to batch-add",
      addedToEng: "{ref} added to this engagement",
      addedCount: "Added {list} to {tab}.",
      permDelTitle: "Permanent deletion",
      permDelDesc: "You are about to remove {ref} — {title} from this engagement.",
      permDelWarn: "The form, its answers and its attachments move to the firm Recycle Bin (30-day restore window); nothing is hard-deleted. Re-adding the form from the Document Library, or Restore from the Recycle Bin, brings the answers back. Other engagements are not affected.",
      permDelTypeRef: "Type the form's reference number {ref} to confirm.",
      permDeleted: "{ref} moved to the Recycle Bin",
      failedDelete: "Failed to delete",
      tabPlanning: "Planning",
      tabRisk: "Risk Assessment Forms",
      tabCompletion: "Completion",
      tabSpecialized: "Specialized & Other Considerations",
    },
    docLibStages: {
      "Acceptance & Continuance": "Acceptance & Continuance",
      "Planning": "Planning",
      "Risk Assessment": "Risk Assessment",
      "Audit Response": "Audit Response",
      "Controls": "Controls",
      "Fieldwork": "Fieldwork",
      "Completion": "Completion",
      "Reporting": "Reporting",
      "Close & Archive": "Close & Archive",
      "Engagement-type forms": "Engagement-type forms (ISA 800 / 805 / 810 — coming soon)",
      "Governance & Quality": "Governance & Quality",
    },
    docFields: {
      status: "Status", yes: "Yes", no: "No", items: "item(s)", predicted_type: "Document type", is_support_document: "Supporting document", classification_confidence: "Confidence",
      primary_reference: "Primary reference", invoice_number: "Invoice number", invoice_date: "Invoice date", customer_name: "Customer", vendor_name: "Vendor / supplier",
      total_amount: "Total amount", tax_amount: "Tax amount", currency: "Currency", due_date: "Due date", po_reference: "PO reference", po_number: "PO number",
      po_date: "PO date", line_items: "Line items", contract_number: "Contract number", contract_date: "Contract date", start_date: "Start date", end_date: "End date",
      counterparty: "Counterparty", parties: "Parties", boq_number: "BOQ number", date: "Date", project_name: "Project", grn_number: "GRN number",
      grn_date: "GRN date", dn_number: "Delivery note number", dn_date: "Delivery note date", account_number: "Account number", bank_name: "Bank",
      statement_date: "Statement date", period_start: "Period start", period_end: "Period end", opening_balance: "Opening balance", closing_balance: "Closing balance",
      subtotal: "Subtotal", description: "Description", payment_terms: "Payment terms", reference: "Reference",
      balance_per_client: "Balance per client", balance_confirmed: "Balance confirmed", as_at_date: "As at", difference_note: "Difference explained",
      certificate_no: "Certificate number", project: "Project", party: "Party", gross_value: "Gross value", retention: "Retention", net_value: "Net value",
      seller_name: "Seller", buyer_name: "Buyer", memo_reference: "Memo reference", from_party: "From", to_party: "To", subject: "Subject", summary: "Summary",   // Batch 29 · item 8
    },
    docLibHeaders: {
      ref: "Ref",
      title: "Form title",
      isa: "ISA / ISRE basis",
      defaultLocation: "Default location",
      engagementTypes: "Engagement types",
      status: "Status",
      allStages: "All stages",
      allTypes: "All engagement types",
      filters: "Filters",
    },
    docLib: {
      selectEng: "Select an engagement to browse the Document Library.",
      loading: "Loading library…",
      searchPlaceholder: "Search by form number or name…",
      noNewAddons: "No new add-ons to add in {tab}.",
      adding: "Adding…",
      deleting: "Deleting…",
      yesDelete: "Yes, delete permanently",
    },
    docsum: {
      title: "Summaries", pick: "Pick a document…", summarise: "Summarise", running: "Summarising…", done: "Summary ready (AI draft — review and accept)",
      failed: "Summary failed", empty: "No summaries yet for this document", accepted: "Accepted", draft: "AI draft", accept: "Accept", reject: "Reject",
      pageTitle: "Document Summaries", pageSubtitle: "AI summaries with page citations — drafts until accepted; one shared document store with Document Review",
      loadFailed: "Could not load documents", upload: "Upload document", uploadFailed: "Upload failed", uploaded: "{n} document(s) uploaded",
      summariseSelected: "Summarise selected", exportAllPdf: "Export all accepted (PDF)", exportAllXlsx: "Export all accepted (XLSX)", exportPdf: "Export summary",
      all: "All statuses", statusNone: "No summary", noDocs: "No documents in this engagement yet", pages: "pages", units: "units",
      deleteDoc: "Delete document", deleteSummary: "Delete summary", deleteDocConfirm: "Move this document and its summaries to the Recycle Bin (30 days)?",
      deleteSummaryConfirm: "Move this summary to the Recycle Bin (30 days)?", binned: "Moved to Recycle Bin",
      pickHint: "Select a document on the left to view or create its summary.", versions: "version(s)", openDoc: "Open document",
      acceptedBy: "accepted by", confirmTitle: "Summarise — confirm", tooLarge: "Too large (max {max} pages)",
      estimateTotal: "{pages} pages · estimated {units} units", draftNote: "The result is an AI draft until you accept it. Units are metered to this engagement.",
      continue: "Continue", page: "Page", openInReview: "Open in Document Review", openInSummaries: "Open in Document Summaries",
    },
    addFromLibrary: {
      title: "Add from library",
      desc: "Search the firm's form library and add a form to this engagement. Every add is logged in the audit trail.",
      empty: "No forms found. Try a different search.",
    },
  },
  ar: {
    docsExtras: {
      duplicateBadge: "تكرار محتمل لـ {ref}",
      permanentFile: "ملف دائم",
      permanentSuggested: "مقترح للملف الدائم",
      permanentFailed: "تعذّر حفظ علامة الملف الدائم",
      duplicatePrompt: "هذا الملف موجود بالفعل باسم {ref} — هل تريد رفعه على أي حال؟",
      linkedToPlural: "تم الربط بـ {plural}",
      linkFailed: "فشل تحديث الربط",
      docDeleted: "تم حذف المستند",
      deleteFailed: "فشل الحذف",
      linkedTick: "تم الربط ✓",
      acceptFailed: "فشل القبول",
      dismissFailed: "فشل الرفض",
      uploadFailedLine: "{name}: {msg}",
      uploadedSingle: "تم الرفع — بدأ استخراج الذكاء الاصطناعي",
      uploadedBatch: "{ok} من {total} تم رفعها — الذكاء الاصطناعي يستخرج الحقول في الخلفية",
      uploadFailedSingle: "فشل الرفع",
      dropzoneTitle: "انقر لاختيار الملفات، أو اسحب وأفلت ملفات متعددة هنا",
      uploadingProgress: "جاري الرفع {done}/{total}…",
      dropToUpload: "أفلت الملفات للرفع",
      uploadOrClick: "{upload} · أفلت أو انقر · الحد الأقصى 100 ميغابايت لكل ملف",
      docsCount: "المستندات ({n})",
      groupedTitle: "مجمّعة حسب رأس الحساب",
      groupedLabel: "مجمّعة",
      flatTitle: "قائمة مسطحة",
      flatLabel: "مسطحة",
      expandAll: "توسيع الكل",
      collapseAll: "طي الكل",
      autoLinkedCount: "{n} تم ربطها بالذكاء الاصطناعي",
      possibleCount: "{n} مع تطابق محتمل بالذكاء الاصطناعي",
      noDocsYet: "لا توجد مستندات بعد.",
      zoomTitle: "فتح المعاينة بملء الشاشة",
      zoomBtn: "تكبير",
      selectDoc: "اختر مستنداً",
      browserBlockedPdf: "منع متصفحك عارض PDF المضمّن.",
      downloadPdf: "تحميل PDF",
      demoDoc: "مستند تجريبي (بدون بايتات)",
      colUid: "المعرف",
      colVoucher: "السند",
      colAccount: "الحساب",
      colAmount: "المبلغ",
      noSampleLines: "لا توجد بنود عينة بعد — قم بتشغيل عينة أولاً.",
      saveWithCount: "حفظ ({n})",
      docPreview: "معاينة المستند",
      docZoomAlt: "معاينة",
      aiConfidenceTitle: "مرتبط بالذكاء الاصطناعي · ثقة {n}%",
      unclassifiedBadge: "غير مصنف",
      unclassifiedWhy: "تعذّر على الاكتشاف التلقائي مطابقة هذا الملف مع نوع مستند مؤيد (فاتورة، أمر شراء، إذن استلام، عقد، جدول كميات، إشعار تسليم، كشف بنكي). محاضر مجلس الإدارة والقوائم المالية المدققة ليست مستندات مؤيدة — حدّد النوع يدويًا أو اتركه هنا.",
      extractionFailed: "فشل الاستخراج — أعد المحاولة",
      possibleAiMatches: "تطابقات محتملة بالذكاء الاصطناعي",
      dismissBtn: "رفض",
      acceptBtn: "قبول",
    },
    docLibExtras: {
      title: "مكتبة المستندات",
      overview: "إجمالي {total} نموذجاً — {inEng} في هذه المهمة، {avail} متاحة للإضافة. النماذج المحذوفة تبقى هنا لإعادة الإضافة.",
      inEngagement: "في هذه المهمة",
      addToEng: "إضافة إلى المهمة",
      noMatch: "لا توجد نماذج مطابقة لـ \"{q}\".",
      failedLoad: "فشل تحميل المكتبة",
      failedAdd: "فشل إضافة النموذج",
      failedBatch: "فشل الإضافة المجمعة",
      addedToEng: "تمت إضافة {ref} إلى هذه المهمة",
      addedCount: "تمت إضافة {list} إلى {tab}.",
      permDelTitle: "حذف نهائي",
      permDelDesc: "أنت على وشك إزالة {ref} — {title} من هذا الارتباط.",
      permDelWarn: "ينتقل النموذج وإجاباته ومرفقاته إلى سلة المحذوفات للمكتب (نافذة استعادة 30 يومًا)؛ لا يُحذف أي شيء نهائيًا. إعادة إضافة النموذج من مكتبة المستندات أو الاستعادة من سلة المحذوفات تُعيد الإجابات. الارتباطات الأخرى لا تتأثر.",
      permDelTypeRef: "اكتب رقم مرجع النموذج {ref} للتأكيد.",
      permDeleted: "تم نقل {ref} إلى سلة المحذوفات",
      failedDelete: "فشل الحذف",
      tabPlanning: "التخطيط",
      tabRisk: "نماذج تقييم المخاطر",
      tabCompletion: "الإنجاز",
      tabSpecialized: "التخصصات والاعتبارات الأخرى",
    },
    docLibStages: {
      "Acceptance & Continuance": "القبول والاستمرارية",
      "Planning": "التخطيط",
      "Risk Assessment": "تقييم المخاطر",
      "Audit Response": "استجابة المراجعة",
      "Controls": "الضوابط",
      "Fieldwork": "العمل الميداني",
      "Completion": "الإكمال",
      "Reporting": "التقرير",
      "Close & Archive": "الإغلاق والأرشفة",
      "Engagement-type forms": "نماذج نوع الارتباط (ISA 800 / 805 / 810 — قريباً)",
      "Governance & Quality": "الحوكمة والجودة",
    },
    docFields: {
      status: "الحالة",
      yes: "نعم", no: "لا", items: "بند(بنود)", predicted_type: "نوع المستند", is_support_document: "مستند داعم", classification_confidence: "درجة الثقة",
      primary_reference: "المرجع الأساسي", invoice_number: "رقم الفاتورة", invoice_date: "تاريخ الفاتورة", customer_name: "اسم العميل", vendor_name: "اسم المورد",
      total_amount: "المبلغ الإجمالي", tax_amount: "مبلغ الضريبة", currency: "العملة", due_date: "تاريخ الاستحقاق", po_reference: "مرجع أمر الشراء", po_number: "رقم أمر الشراء",
      po_date: "تاريخ أمر الشراء", line_items: "بنود السطر", contract_number: "رقم العقد", contract_date: "تاريخ العقد", start_date: "تاريخ البدء", end_date: "تاريخ الانتهاء",
      counterparty: "الطرف المقابل", parties: "الأطراف", boq_number: "رقم جدول الكميات", date: "التاريخ", project_name: "اسم المشروع", grn_number: "رقم إشعار الاستلام",
      grn_date: "تاريخ إشعار الاستلام", dn_number: "رقم إشعار التسليم", dn_date: "تاريخ إشعار التسليم", account_number: "رقم الحساب", bank_name: "اسم البنك",
      statement_date: "تاريخ الكشف", period_start: "بداية الفترة", period_end: "نهاية الفترة", opening_balance: "الرصيد الافتتاحي", closing_balance: "الرصيد الختامي",
      subtotal: "المجموع الفرعي", description: "الوصف", payment_terms: "شروط الدفع", reference: "المرجع",
      balance_per_client: "الرصيد حسب العميل", balance_confirmed: "الرصيد المصادق عليه", as_at_date: "كما في", difference_note: "تفسير الفرق",
      certificate_no: "رقم الشهادة", project: "المشروع", party: "الطرف", gross_value: "القيمة الإجمالية", retention: "المحتجزات", net_value: "القيمة الصافية",
      seller_name: "البائع", buyer_name: "المشتري", memo_reference: "مرجع المذكرة", from_party: "من", to_party: "إلى", subject: "الموضوع", summary: "الملخص",   // Batch 29 · item 8
    },
    docLibHeaders: {
      ref: "المرجع",
      title: "عنوان النموذج",
      isa: "الأساس (ISA/ISRE)",
      defaultLocation: "الموقع الافتراضي",
      engagementTypes: "أنواع الارتباط",
      status: "الحالة",
      allStages: "كل المراحل",
      allTypes: "كل أنواع الارتباط",
      filters: "الفلاتر",
    },
    docLib: {
      selectEng: "اختر مهمة لتصفح مكتبة المستندات.",
      loading: "جاري تحميل المكتبة…",
      searchPlaceholder: "ابحث برقم النموذج أو اسمه…",
      noNewAddons: "لا توجد إضافات جديدة لإضافتها في {tab}.",
      adding: "جاري الإضافة…",
      deleting: "جاري الحذف…",
      yesDelete: "نعم، احذف نهائياً",
    },
    docsum: {
      title: "الملخصات", pick: "اختر مستندًا…", summarise: "تلخيص", running: "جاري التلخيص…", done: "الملخص جاهز (مسودة ذكاء اصطناعي — راجع واقبل)",
      failed: "فشل التلخيص", empty: "لا توجد ملخصات لهذا المستند بعد", accepted: "مقبول", draft: "مسودة ذكاء اصطناعي", accept: "قبول", reject: "رفض",
      pageTitle: "ملخصات المستندات", pageSubtitle: "ملخصات بالذكاء الاصطناعي مع إحالات للصفحات — مسودات حتى القبول؛ مخزن مستندات مشترك مع مراجعة المستندات",
      loadFailed: "تعذر تحميل المستندات", upload: "رفع مستند", uploadFailed: "فشل الرفع", uploaded: "تم رفع {n} مستند(ات)",
      summariseSelected: "تلخيص المحدد", exportAllPdf: "تصدير كل المقبول (PDF)", exportAllXlsx: "تصدير كل المقبول (XLSX)", exportPdf: "تصدير الملخص",
      all: "كل الحالات", statusNone: "بدون ملخص", noDocs: "لا توجد مستندات في هذه المهمة بعد", pages: "صفحات", units: "وحدات",
      deleteDoc: "حذف المستند", deleteSummary: "حذف الملخص", deleteDocConfirm: "نقل هذا المستند وملخصاته إلى سلة المحذوفات (30 يومًا)؟",
      deleteSummaryConfirm: "نقل هذا الملخص إلى سلة المحذوفات (30 يومًا)؟", binned: "تم النقل إلى سلة المحذوفات",
      pickHint: "اختر مستندًا من اليمين لعرض ملخصه أو إنشائه.", versions: "إصدار(ات)", openDoc: "فتح المستند",
      acceptedBy: "قبله", confirmTitle: "تلخيص — تأكيد", tooLarge: "كبير جدًا (الحد الأقصى {max} صفحة)",
      estimateTotal: "{pages} صفحة · الوحدات المقدرة {units}", draftNote: "النتيجة مسودة ذكاء اصطناعي حتى تقبلها. تُحتسب الوحدات على هذه المهمة.",
      continue: "متابعة", page: "صفحة", openInReview: "فتح في مراجعة المستندات", openInSummaries: "فتح في ملخصات المستندات",
    },
    addFromLibrary: {
      title: "إضافة من المكتبة",
      desc: "ابحث في مكتبة نماذج الشركة وأضف نموذجاً إلى هذه المهمة. يتم تسجيل كل إضافة في سجل المراجعة.",
      empty: "لم يتم العثور على نماذج. جرّب بحثاً مختلفاً.",
    },
  },
};

export default I18N_BASE_DOCUMENTS;
